import { LicenseInfo } from '@mui/x-license';

const LICENSE_KEY =
  'c84ec596e60312bb54cc3c00a93395acTz0xMjc0NzcsRT0xODA2MTA1NTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y';

export function setMuiLicenseKey(): void {
  LicenseInfo.setLicenseKey(LICENSE_KEY);
}
